<template>
  <section>
    <form action v-on:submit.prevent="editDocument">
      <div class="modal-card" style="height: 1000px; width: 100%">
        <header class="modal-card-head">
          <p>Editar Documento</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-tabs type="is-boxed">
            <b-tab-item label="Detalle">
              <div class="columns is-mobile is-desktop">
                <div class="column">
                  <b-field
                    label="Fecha del documento en papel"
                    :label-position="'on-border'"
                  >
                    <b-datepicker
                      v-model="document.date_document"
                      :locale="'en-US'"
                      placeholder="Seleccionar Fecha"
                      :day-names="calendario.dias"
                      :month-names="calendario.meses"
                      icon="calendar-alt"
                      trap-focus
                      required
                    >
                    </b-datepicker>
                  </b-field>
                  <b-field
                    label="Número de documento"
                    :label-position="'on-border'"
                  >
                    <b-input v-model="document.number" required></b-input>
                  </b-field>
                  <b-field label="Descripción" :label-position="'on-border'">
                    <b-input
                      v-model="document.description"
                      type="textarea"
                      required
                    ></b-input>
                  </b-field>
                  <b-field
                    label="Tipo de documento"
                    :label-position="'on-border'"
                  >
                    <b-select
                      placeholder="Seleccionar tipo  de documento"
                      v-model="document.document_type_id"
                      expanded
                      required
                    >
                      <option
                        v-for="option in listDocumentType"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    label="Seleccionar tipo de remitente"
                    :label-position="'on-border'"
                  >
                    <b-select
                      placeholder="Seleccionar tipo de remitente"
                      v-model="document.type_remitent_id"
                      expanded
                      required
                      @change.native="changeSelect"
                    >
                      <option
                        v-for="option in listTypeRemitent"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field
                    v-if="document.type_remitent_id !== 3"
                    label="Seleccionar remitente"
                    :label-position="'on-border'"
                  >
                    <b-select
                      placeholder="Seleccionar remitente"
                      v-model="document.remitent_id"
                      expanded
                      required
                      :loading="loadingSelect"
                    >
                      <option
                        v-for="option in listRemitent"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <div>
                    <b-field label="Seleccionar Distribución"></b-field>
                    <b-field>
                      <b-radio-button
                        v-model="document.with_distribution"
                        :native-value="false"
                        type="is-danger"
                      >
                        <b-icon icon="times"></b-icon>
                        <span>No</span>
                      </b-radio-button>

                      <b-radio-button
                        v-model="document.with_distribution"
                        :native-value="true"
                        type="is-success"
                      >
                        <b-icon icon="check"></b-icon>
                        <span>Si</span>
                      </b-radio-button>
                    </b-field>
                  </div>
                  <br />
                  <b-field
                    v-if="document.with_distribution"
                    label="Lista de distribución"
                    :label-position="'on-border'"
                  >
                    <b-taginput
                      v-model="selectedDistribution"
                      :data="filteredTags"
                      autocomplete
                      open-on-focus
                      field="name"
                      icon="tags"
                      placeholder="Favor de escribir para buscar en listado"
                      @typing="getFilteredTags"
                    >
                    </b-taginput>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item label="Archivo">
              <b-field label="Archivo" :label-position="'on-border'">
                <b-upload v-model="new_file" class="file-label">
                  <span class="file-cta">
                    <b-icon class="file-icon" icon="upload"></b-icon>
                    <span class="file-label"
                      >Haga click aqui para seleccionar archivo</span
                    >
                  </span>
                  <span class="file-name" v-if="new_file">
                    {{ new_file.name }}
                  </span>
                </b-upload>
              </b-field>
              <h1 class="is-size-4">Documento Actual</h1>
              <iframe
                :src="document.file"
                style="width: 100%; height: 500px"
                allowfullscreen
                webkitallowfullscreen
              ></iframe>
            </b-tab-item>
          </b-tabs>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import moment from "moment";
// import { postDocument } from "../../../services/document";
// import { getDocumentType } from "../../../services/document_type";
// import { getCellar } from "../../../services/cellar";
// import { getRemitentFindByType } from "../../../services/remitent";
// import { getTypeRemitent } from "../../../services/type_remitent";
import { DocumentTypeService } from "../../../services/models/document_type";
import { CellarService } from "../../../services/models/cellar";
import { RemitentService } from "../../../services/models/remitent";
import { TypeRemitentService } from "../../../services/models/type_remitent";
import { DocumentService } from "../../../services/models/document";
import { DistributionService } from "../../../services/models/distribution";
import { Document_DistributionService } from "../../../services/models/document_distribution";

export default {
  props: ["chargeDocumentList", "directory_id", "documentProp"],
  data() {
    return {
      selectedDistribution: [],
      openOnFocus: true,
      listDistributions: [],
      filteredTags: this.listDistributions,

      isLoading: false,
      loadingSelect: false,
      listDocumentType: [],
      listCellar: [],
      listRemitent: [],
      listTypeRemitent: [],
      document: {
        number: null,
        description: null,
        date_document: new Date(),
        file: null,
        favorite: false,
        document_type_id: null,
        cellar_id: this.$route.params.cellarId
          ? this.$route.params.cellarId
          : this.$route.params.id,
        remitent_id: null,
        type_remitent_id: 1,
        directory_id: this.directory_id == null ? null : this.directory_id,
        state_directory:
          this.directory_id == null ? "Sin Directorio" : "Con Directorio",
        with_distribution: null,
      },
      new_file: null,
      calendario: {
        meses: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        dias: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
      },
    };
  },
  mounted() {
    this.chargeData();
    if (this.documentProp) {
      this.document = this.documentProp;
      this.document.date_document = new Date(this.documentProp.date_document);
      this.document.date_document.setDate(
        this.document.date_document.getDate() + 1
      );
      if (this.documentProp.with_distribution == 0) {
        this.document.with_distribution = false;
      } else {
        this.document.with_distribution = true;
      }
    }
  },
  methods: {
    getFilteredTags(text) {
      this.filteredTags = this.listDistributions.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    async chargeData() {
      this.isLoading = true;
      const { data: documentTypes } = await DocumentTypeService.getAll();
      this.listDocumentType = documentTypes.data;      
      const { data: cellars } = await CellarService.getAll();
      this.listCellar = cellars.data;      
      const { data: remitents } = await RemitentService.getRemitentFindByType(
        this.document.type_remitent_id
      );
      this.listRemitent = remitents;      
      const { data: remitentTypes } = await TypeRemitentService.getAll();
      this.listTypeRemitent = remitentTypes.data;      
      const { data: distributions } = await DistributionService.getAll();
      this.listDistributions = distributions.data;

      this.isLoading = false;
    },
    async changeSelect() {
      this.loadingSelect = true;
      const { data: remitents } = await RemitentService.getRemitentFindByType(
        this.document.type_remitent_id
      );
      this.listRemitent = remitents;      
      this.loadingSelect = false;
    },
    async editDocument() {
      if (this.document.date_document != null) {
        this.isLoading = true;
        this.document.date_document = moment(
          this.document.date_document,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        const { data: document } = await DocumentService.update(
          this.documentProp.id,
          this.document
        );
        if (this.new_file) {
          let formData = new FormData();
          formData.append("file", this.new_file);
          await DocumentService.putFile(this.documentProp.id, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }
        if (this.document.with_distribution) {
          for (let i = 0; i < this.selectedDistribution.length; i++) {
            let data = {
              document_id: document.id,
              distribution_id: this.selectedDistribution[i].id,
            };
            await Document_DistributionService.create(data);
          }
        }
        this.$buefy.notification.open({
          message: "Documento Ingresado!",
          type: "is-success",
        });
        this.chargeDocumentList();
        this.$parent.close();
        this.isLoading = false;
      } else {
        this.$buefy.notification.open({
          message: "Ingrese todos los campos por favor!",
          type: "is-danger",
        });
      }
    },
  },
};
</script>